import Vue from 'vue'
import Player from '../models/player'
import ApiBase from '@/api/apiBase'

class ApiPlayers {

    static all(callBack, errorCallBack) {
        ApiBase.get(`/players`, callBack, ApiPlayers.parseAll, errorCallBack)
    }
    static allInTeam(teamId,callBack, errorCallBack) {
        /*for(var i in response.data.data){
            result.push(Player.parse(response.data.data[i]))
        }*/
        ApiBase.get(`/players`, callBack, ApiPlayers.parseAll, errorCallBack)
    }

    static create(player, callBack, errorCallBack) {
        let formData = new FormData()
        formData.append('name', player.name)
        formData.append('team_id', player.teamId)

        if(player.photo){
            formData.append('photo', player.photo)
        }

        ApiBase.post(`players`, formData, callBack, ApiBase.noParse, errorCallBack)
    }

    static update(playerID, player, callBack, errorCallBack) {
        /*let formData = new FormData()
        formData.append('name', player.name)
        formData.append('team_id', player.team_id)

        if(player.photo) {
            formData.append('photo', player.photo)
        }*/

        let data = {
            "name": player.name,
            "team_id": player.teamId
        }
        console.log("DATA",data)

        ApiBase.put(`players/${playerID}`, data, callBack, ApiBase.noParse, errorCallBack)
    }

    static delete(player, callBack, errorCallBack){
      ApiBase.delete(`/players/${player.id}`,callBack,ApiBase.noParse,errorCallBack)
    }

    static find(playerID, callBack, errorCallBack) {
        ApiBase.get(`/players/${playerID}`, callBack, ApiPlayers.parseFinded, errorCallBack)
    }
    static officialInfo(playerId, callBack, errorCallBack){
      ApiBase.get(`/players/${playerId}/official-info`, callBack, ApiBase.noParse, errorCallBack)
    }

    static parseFinded(response) {
        return Player.parse(response.data.data)
    }

    static parseAll(response){
        let result = []
        for(var i in response.data.data){
            result.push(Player.parse(response.data.data[i]))
        }
        return result
    }


}

export default ApiPlayers



// WEBPACK FOOTER //
// ./src/api/apiPlayers.js